import React from 'react';
interface IProps {
    active: boolean;
    fill?: string;
}
export default ({ active, fill }: IProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 110 154"><g><polygon fill={fill || (active ? `var(--redRock)` : 'var(--mud)')} points="110 54 55 154 0 54 55 0 110 54" /></g></svg>
    );
}